module.exports = __webpack_public_path__ + "img/value-teaser-02.24057053.jpg";